// extracted by mini-css-extract-plugin
export default {"root":"BizItemName__root--awP5I"};